<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 0H0v22h22V0Z" fill="white" fill-opacity=".01" />
    <path
      d="M10.996 2.75H2.75v16.5H11M15.125 15.125 19.25 11l-4.125-4.125M7.333 10.996H19.25"
      :stroke="disabled ? disabledColor : color"
      stroke-width="1.688"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ExitIcon extends Vue {
  @Prop() disabled: boolean;
  @Prop({ type: String, default: '#FFFFFF' }) color: boolean;
  @Prop({ type: String, default: '#9FAAD2' }) disabledColor: boolean;
}
</script>
